// extracted by mini-css-extract-plugin
export var container = "_dl-0";
export var popoverContent = "_dl-1";
export var tosLink = "_dl-2";